import React, { useEffect, useState } from "react";
import { fetchImageBlobUrl } from "../api";

/**
 * Renders the avatar image if available (via authenticated blob fetch), fallback to emoji.
 * size: number in px
 */
export default function CloneAvatar({ clone, size = 48, className = "" }) {
  const [url, setUrl] = useState(null);
  const path = clone?.avatar_image_path;
  const emoji = clone?.avatar_emoji || "🧠";

  useEffect(() => {
    let currentUrl = null;
    let cancelled = false;
    if (path) {
      fetchImageBlobUrl(path)
        .then((u) => {
          if (cancelled) {
            URL.revokeObjectURL(u);
            return;
          }
          currentUrl = u;
          setUrl(u);
        })
        .catch(() => setUrl(null));
    } else {
      setUrl(null);
    }
    return () => {
      cancelled = true;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [path]);

  const style = { width: `${size}px`, height: `${size}px`, fontSize: `${Math.max(16, size * 0.5)}px` };

  if (url) {
    return (
      <img
        src={url}
        alt="avatar"
        style={style}
        className={`object-cover rounded-md bg-zinc-100 ${className}`}
        data-testid="clone-avatar-img"
      />
    );
  }
  return (
    <div
      style={style}
      className={`bg-zinc-100 rounded-md flex items-center justify-center ${className}`}
      data-testid="clone-avatar-emoji"
    >
      {emoji}
    </div>
  );
}
